import { render, staticRenderFns } from "./multi-select.vue?vue&type=template&id=533c0055&scoped=true"
import script from "./multi-select.js?vue&type=script&lang=js&external"
export * from "./multi-select.js?vue&type=script&lang=js&external"
import style0 from "./multi-select.scss?vue&type=style&index=0&id=533c0055&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533c0055",
  null
  
)

export default component.exports